import { PropsWithChildren } from "react";
import { SkeletonTheme } from "react-loading-skeleton";

import { ThemeContext } from "./ThemeContext";
import { useTheme } from "./useTheme";

const skeletonTheme = {
  dark: {
    baseColor: "var(--color-karlis-black-080)",
    highlightColor: "var(--primary-light)",
  },
  light: {
    baseColor: "var(--color-elvira-gray-020)",
    highlightColor: "rgb(from var(--color-affire-pink-090) r g b / 20%)",
  },
} as const;

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const theme = useTheme();

  return (
    <SkeletonTheme
      baseColor={skeletonTheme[theme.theme].baseColor}
      highlightColor={skeletonTheme[theme.theme].highlightColor}
    >
      <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
    </SkeletonTheme>
  );
};
